import { useEffect, useState } from 'react';

/**
 * Atrasa a propagação de um valor até ele ficar parado por `delayMs`.
 *
 * Uso principal: campo de busca que alimenta uma queryKey do react-query
 * (`['customers','dropdown', termo]`). Sem isto, cada tecla vira uma requisição.
 *
 * O valor INICIAL sai sem atraso — quem monta o painel já vê a lista sem busca.
 *
 * @example
 * const [termo, setTermo] = useState('');
 * const termoDebounced = useDebouncedValue(termo, 300);
 * const { data } = useCustomersDropdown({ enabled: aberto, search: termoDebounced });
 */
export function useDebouncedValue<T>(value: T, delayMs: number): T {
  const [debounced, setDebounced] = useState<T>(value);

  useEffect(() => {
    const timer = setTimeout(() => setDebounced(value), delayMs);
    return () => clearTimeout(timer);
  }, [value, delayMs]);

  return debounced;
}
